import "./App.css";
import SpeechPage from "./components/SpeechPage";

function App() {
  return <SpeechPage />;
}

export default App;
